import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useSetPatientFiIntegration = (options = {}) => {
  const res = useMutation(
    async (dto) =>
      http.put(
        HTTP_ENDPOINTS.patientFiIntegration.putPatientFiIntegration(),
        dto,
      ),
    { ...options },
  );
  return res;
};
